
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">
           
            <collection-builder-edit *ngSwitchCase="true"></collection-builder-edit>
            <collection-builder-details *ngSwitchCase="false"></collection-builder-details>
        </div>
    </ng-template>  
</main-form-modal>